import { render } from "./MakeUpOrderList.vue?vue&type=template&id=4145c3f2&scoped=true"
import script from "./MakeUpOrderList.vue?vue&type=script&lang=js"
export * from "./MakeUpOrderList.vue?vue&type=script&lang=js"

import "./MakeUpOrderList.vue?vue&type=style&index=0&id=4145c3f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4145c3f2"],['__file',"src/views/h5/common/stock/makeUp/MakeUpOrderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4145c3f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4145c3f2', __exports__)) {
    api.reload('4145c3f2', __exports__)
  }
  
  module.hot.accept("./MakeUpOrderList.vue?vue&type=template&id=4145c3f2&scoped=true", () => {
    api.rerender('4145c3f2', render)
  })

}


export default __exports__